import { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';
import menu from '../../assets/images/icons/menu.svg';
import Navbar from '../Navbar';
import { Container, LogoContainer, OffcanvasStyle } from './styles';

import logo from '../../assets/images/Logo.svg';
import { useAppContext } from '../../contexts/auth';

interface SidebarInterface {
  active: string;
}

export default function Sidebar({ active }: SidebarInterface) {
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(window.screen.width);
  const { logoUrl, isDifferentSubdomain } = useAppContext();
  console.log(logoUrl);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  window.onresize = () => setWidth(window.screen.width);

  return (
    width > 1199
      ? (
        <Container>
          <LogoContainer isLogoFull={isDifferentSubdomain}>
            <Link to="/">
              <img src={logoUrl || logo} alt="logo" />
            </Link>
          </LogoContainer>
          <Navbar active={active} />
        </Container>
      )
      : (
        <>
          <button className="menuButton" type="button" onClick={handleShow}>
            <img src={menu} alt="menu" />
          </button>
          <OffcanvasStyle>
            <Offcanvas show={show} onHide={handleClose} style={{ width: 200 }}>
              <LogoContainer isLogoFull={isDifferentSubdomain}>
                <Link to="/">
                  <img src={logoUrl || logo} alt="logo" />
                </Link>
              </LogoContainer>
              <Navbar active={active} />
            </Offcanvas>
          </OffcanvasStyle>
        </>
      )

  );
}
